import { t } from '../../utils/i18n';
import { appointmentDuration, appointmentSummary, form, leadInfo, locations, primaryColor, providerId, providers, staffProcedures } from "../../utils/variables";
import { formatPhoneNumber } from "../../modules/actions/countryCodeActions";
import parsePhoneNumberFromString from 'libphonenumber-js';

export async function loadSelectedAppointmentTime() {
    if (appointmentDuration.requires_consult) {
        const banner = document.querySelector('.appointment-summary__container .appointment__banner');
        banner.style.display = 'flex';
        banner.querySelector('.message span').innerText = appointmentSummary.duration;
    }
    let startTime = appointmentSummary.event.start_time;
    document.querySelector('.appointment-summary__container .appointment-time .name-title span')
        .textContent = moment(startTime * 1000).format('hh:mm A');
    document.querySelector('.appointment-summary__container .appointment-time .detail-info').innerHTML = '';
    document.querySelector('.appointment-summary__container .appointment-time .detail-info')
        .insertAdjacentHTML('beforeend',
            `<span>${moment(startTime * 1000).format('dddd')}</span><br>${moment(startTime * 1000).format('MMMM DD, YYYY')}`);
    let duration = document.querySelector('.appointment-summary__container .appointment-time .name-title .duration');
    duration.style.background = `${primaryColor}09`;

    const durationTime = moment.duration(appointmentDuration.duration, 'm');

    if (durationTime._data.hours >= 0 && durationTime._data.minutes > 0) {
        duration.textContent = `${moment.duration(appointmentDuration.duration, 'm').format('h[h] m')}min`;
    } else {
        duration.textContent = moment.duration(appointmentDuration.duration, 'm').format('h[h]');
    }
}

export async function loadCustomerName() {
    document.querySelector('.appointment-summary__body .greeting')
        .textContent = `${t('greeting_hi')} ${leadInfo?.first_name || ''} ${leadInfo?.last_name || ''}, `;
}

export async function loadLocationInformation() {
    let selectedLocationObj = locations.find(e => e.id === appointmentSummary.event.location_id);
    let selectedStaffsObj = providers.filter(e => appointmentSummary.staffs?.map(i => i.participable_id)?.includes(e.id));
    const staffNames = selectedStaffsObj?.map(i => `${i?.first_name} ${i?.last_name}`)
    document.querySelector('.appointment-summary__container .appointment-location .name-title span')
        .textContent = staffNames.join(', ');
    const nameSpan = document.querySelector('.appointment-summary__container .appointment-location .name-title span');
    if (nameSpan) {
        nameSpan.classList.toggle('wrap-name', selectedStaffsObj?.length > 1);
    }

    // Treat the visit as virtual when the channel is a virtual meeting, OR when
    // every selected service is delivered fully virtually (service_delivery_mode).
    // A fully-virtual service can still carry a physical location_id, so we must
    // not show that address — mirror the channel's virtual display instead.
    const selectedProcedures = appointmentSummary.event.procedures ?? [];
    const allFullyVirtual = selectedProcedures.length > 0
        && selectedProcedures.every((procedure) => procedure?.service_delivery_mode === 'fully_virtual');
    const hasVirtualVisit = form?.appointment_channel?.is_virtual_meeting || allFullyVirtual;

    let locationInfo = '';
    if (hasVirtualVisit) {
        const phoneNumber = selectedLocationObj?.phone || '';
        let formattedPhone = phoneNumber;

        if (phoneNumber) {
            try {
                const parsedPhone = parsePhoneNumberFromString(phoneNumber, selectedLocationObj?.country || 'US');
                if (parsedPhone && parsedPhone.isValid()) {
                    formattedPhone = parsedPhone.formatNational();
                } else {
                    formattedPhone = formatPhoneNumber(phoneNumber, selectedLocationObj?.country || 'US');
                }
            } catch (error) {
                formattedPhone = phoneNumber;
            }
        }

        locationInfo = `<span>${t('virtual')}</span>${formattedPhone ? `<span title="${t('click_to_copy')}">${formattedPhone}</span>` : ''}`;
    } else {
        let address = selectedLocationObj?.address1 ? `${selectedLocationObj.address1}, ` : '';
        let city = selectedLocationObj?.city ? `${selectedLocationObj.city}, ` : '';
        let state = selectedLocationObj?.state ? `${selectedLocationObj.state}, ` : '';
        let country = selectedLocationObj?.country ? `${selectedLocationObj.country}` : '';
        locationInfo = `<span>${selectedLocationObj.name}</span><span title="${t('click_to_copy')}">${address}${city}${state}${country}</span>`;
    }

    document.querySelector('.appointment-summary__container .appointment-location .detail-info').innerHTML = locationInfo;
}

export async function loadAppoimentDetails() {
    let listWrapperDOM = document.querySelector('.appointment-summary__body .appoitment-details .appoitment-details__info .procedure__list');
    let totalPriceDOM = document.querySelector('.appointment-summary__container .appointment-summary__actions .total .price');
    let totalTitleDOM = document.querySelector('.appointment-summary__container .appointment-summary__actions .total .title ');
    const showPricingForAll = appointmentSummary.event.procedures
        ?.every((procedure) => procedure?.show_pricing);

    document.querySelector('.appointment-summary__body .appoitment-details .appoitment-details__info')
        .style.background = `${primaryColor}09`;

    if (appointmentSummary.event.procedures.length === 0) {
        listWrapperDOM.innerHTML = '';
        listWrapperDOM.insertAdjacentHTML('beforeEnd',
            `<div class="procedure__item--empty"><div class="message">${t('no_procedures_selected')}</div></div>`
        );
        totalPriceDOM.textContent = '';
    } else {
        let listItemHTML = '';
        appointmentSummary.event.procedures.forEach(procedure => {
            listItemHTML += `
                <div class="procedure__item">
                    <div class="name-duration">
                        <div class="name">
                            ${procedure.name || ''}
                        </div>
                        <div class="duration">
                            ${appointmentDuration.requires_consult
                    ? ''
                    : duration(procedure)
                }
                           
                        </div>
                    </div>
                    <div class='price-label ${procedure.min_cost && procedure?.show_pricing ? '' : 'bg-transparent'}'>
                        ${procedure.min_cost && procedure?.show_pricing ? `$${procedure.min_cost}` : ''
                }
                    </div>
                </div>
            `;
        });
        listWrapperDOM.innerHTML = '';
        listWrapperDOM.insertAdjacentHTML('beforeend', listItemHTML);

        document.querySelectorAll('.appointment-summary__body .appoitment-details .appoitment-details__info .procedure__list .procedure__item .price-label')
            .forEach(element => {
                element.style.background = `${primaryColor}0f`;
                element.style.color = `${primaryColor}`;
            });

        if (showPricingForAll) {
            const totalStaffs = appointmentSummary?.staffs?.length
            const pricing = totalStaffs === 1 ? appointmentSummary.estimate.min_total : totalStaffs > 1 ? appointmentSummary.estimate.min_cost : 0
            totalPriceDOM.textContent = pricing ? `$${pricing}` : '';
            totalTitleDOM.textContent = t('total_services').replace('{count}', appointmentSummary.event.procedures.length);
        }
    }
}

export async function renderSelectedProcedureItem(htmlContent) {
    let listWrapperDOM = document.querySelector('.appointment-summary__body .appoitment-details .appoitment-details__info .procedure__list');
    listWrapperDOM.innerHTML = '';
    listWrapperDOM.insertAdjacentHTML('beforeend', htmlContent);
}

export async function loadAppoimentsSummary() {
    loadAppoimentDetails();
    loadLocationInformation();
    loadSelectedAppointmentTime();
    loadCustomerName();
}

function duration(procedure) {
    if (!staffProcedures?.length || !procedure?.i) return '';

    const staffProcedureSelect = staffProcedures.filter(
        item => item.staff_id === providerId
    );

    if (!staffProcedureSelect.length) return '';

    const durationProcedure = staffProcedureSelect.find(
        item => item.procedure_id === procedure.i
    );

    if (!durationProcedure?.duration) return '';

    const durationTime = moment.duration(durationProcedure.duration, 'm');

    return `${durationTime.hours() ? `${durationTime.hours()}h` : ''} ${durationTime.minutes()}min`;
}
